import { EntityModel } from '@/interfaces'
import {
  ALL_PASSPORT_CONFIGS_QUERY,
  CREATE_PASSPORT_CONFIG_MUTATION,
  DELETE_PASSPORT_CONFIG_MUTATION,
  FORCE_DELETE_PASSPORT_CONFIG_MUTATION,
  SINGLE_PASSPORT_CONFIG_QUERY,
  UPDATE_PASSPORT_CONFIG_MUTATION,
} from './graphql'

const travelPricingPassportConfigModel: EntityModel = {
  name: 'passportConfig',
  namePlural: 'passportConfigs',
  uniqueName: 'travelPricingPassportConfig',
  uniqueNamePlural: 'travelPricingPassportConfigs',
  path: 'travel/pricing/passport_config',
  baseUrl: '/travel/pricing/passport_configs',
  translationPrefix: 'entities:travelPricingPassportConfig.',
  getDisplayName: (values: any) => {
    return 'PASSPORT CONFIG'
  },
  gql: {
    getAll: ALL_PASSPORT_CONFIGS_QUERY,
    getSingle: SINGLE_PASSPORT_CONFIG_QUERY,
    create: CREATE_PASSPORT_CONFIG_MUTATION,
    update: UPDATE_PASSPORT_CONFIG_MUTATION,
    delete: DELETE_PASSPORT_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_PASSPORT_CONFIG_MUTATION,
  },
  attributes: {
    passportOnly: {
      name: 'passportOnly',
      label: 'entities:travelPricingPassportConfig.attributes.passportOnly.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingPassportConfigModel
